// extracted by mini-css-extract-plugin
module.exports = {"ServiceName":"styles_ServiceName__3f7P7","ServiceName-label":"styles_ServiceName-label__1Djf1"};